import React from "react";
import { Card, TextField, Image } from "components";
import { Button } from "egov-ui-framework/ui-atoms";
import Label from "egov-ui-kit/utils/translationNode";
import logoImage from "egov-ui-kit/assets/images/logoImage.png";
import "./index.css";
import { CityPicker } from "modules/common";

const ForgotPasswd = ({ form, handleFieldChange, logoUrl }) => {
  const fields = form.fields || {};
  const submit = form.submit;

  return (
    <Card
      className="user-screens-card forgot-passwd-card col-lg-offset-4 col-lg-4 col-md-offset-4 col-md-4"
      textChildren={
        <div>
          <div className="rainmaker-displayInline login-form-screen" style={{ justifyContent: "center", alignItems: "center", marginBottom: "24px" }}>
            <div className="all-login-logo">
              <Image
                className="mseva-logo"
                // source={logoUrl?logoUrl:`${logo}`}
                source={logoImage}
                // source="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Seal_of_Uttar_Pradesh.svg/1024px-Seal_of_Uttar_Pradesh.svg.png"
              />
            </div>
            {/* <div style={{marginLeft:"7px" }}>
          <Label bold={true}  fontSize= "23px" label="|" />
          </div> */}
            {/* <div style={{ marginTop: "20px" }}>
              <Label bold={true} color="black" fontSize="24px" label="STATE_LABEL" />
            </div> */}
          </div>
          <div style={{ marginTop:'52px'}}>
          <Label
            style={{ marginBottom: "12px" }}
            className="text-center forgotpasswd"
            bold={true}
            dark={true}
            fontSize={16}
            label="FORGOT PASSWORD"
          />
          </div>
          <TextField
            onChange={(e, value) => {
              const numbersOnly = value.replace(/[^0-9]/g, "").slice(0, 10);
              handleFieldChange("username", numbersOnly);
            }}
            inputProps={{ maxLength: 10 }}
            textFieldStyle={{ bottom: 16 }}
            prefixStyle={{ top: 21 }}
            {...fields.username}
          />
          <div className="citypicker-style forgot-password-citypicker">
            <CityPicker onChange={handleFieldChange} fieldKey="tenantId" field={fields.tenantId} />
          </div>

          <div className="forgot-password-wrapper">
            <Button
              id="login-submit-action"
              className="common-all-btn"
              {...submit}
              style={{
                height: "48px",
                width: "100%",
              }}
              variant={"contained"}
              color={"primary"}
            >
              <Label buttonLabel={true} labelStyle={{ fontWeight: 500 }} label="CONTINUE" />
            </Button>
          </div>

          {/* <Button id="login-submit-action" primary={true} label="CONTINUE" fullWidth={true} {...submit} /> */}
        </div>
      }
    />
  );
};

export default ForgotPasswd;



// WEBPACK FOOTER //
// src/modules/employee/User/ForgotPassword/components/ForgotPasswd/index.js